module.exports = __webpack_public_path__ + "static/img/edit_b.7b0d2ff4.png";